import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "px-4 py-6 at-nav-standard-dashboard"
};
const _hoisted_2 = {
  class: "grid gap-5 grid-cols-2 lg:grid-cols-3"
};
const _hoisted_3 = {
  class: "bg-blue-200 shadow-sm opacity-60 p-1 px-2 text-xs learn-more-report max-w-md text-left"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  class: "grid gap-5 grid-cols-2 lg:grid-cols-3"
};
const _hoisted_6 = {
  class: "px-3 py-4"
};
const _hoisted_7 = {
  class: "mb-4 text-lg font-normal leading-6 text-gray-900"
};
import { onMounted, reactive, computed } from 'vue';
import reportDashboardOptions from './reportDashboardOptions';
import sidebarCard from './SidebarCard.vue';
import { useSupportChat } from '@/composables/useSupportChat';
export default {
  __name: 'NavStandardDashboard',
  props: {
    reportState: {
      type: Object,
      required: true
    },
    routeService: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const {
      getSupportUrl: _getSupportUrl
    } = useSupportChat();
    const reportsOverviewUrl = computed(() => _getSupportUrl('reportsOverview'));
    const props = __props;
    const dashboardState = reactive({
      reportOptions: {},
      me: {}
    });
    onMounted(async () => {
      dashboardState.me = await props.userService.getMe();
      const {
        settings
      } = dashboardState.me?.company;
      const customFlagLabel = settings?.labels && settings?.labels.customFlag;
      dashboardState.reportOptions = reportDashboardOptions({
        me: dashboardState.me,
        customFlagLabel: customFlagLabel
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)), _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)), _createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "fa fa-arrow-right"
      }, null, -1)), _createElementVNode("a", {
        href: reportsOverviewUrl.value,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          "color": "unset"
        }
      }, " Learn more about reports", 8, _hoisted_4)])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dashboardState.reportOptions, (reportOption, ids) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "max-w-md shadow-md rounded-lg my-5 bg-gray-50",
          key: ids
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(reportOption.label), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportOption.options, (option, ids) => {
          return _openBlock(), _createElementBlock("div", {
            key: ids
          }, [_withDirectives(_createVNode(sidebarCard, {
            label: option.label,
            reportType: option.reportType,
            tooltipData: option.tooltipData,
            dateRangeOptions: option.dateRangeOptions,
            routeService: __props.routeService,
            generic: option.generic,
            state: __props.state,
            stateParams: __props.stateParams
          }, null, 8, ["label", "reportType", "tooltipData", "dateRangeOptions", "routeService", "generic", "state", "stateParams"]), [[_vShow, option.showReport]])]);
        }), 128))])])), [[_vShow, reportOption.showReportList]]);
      }), 128))])]);
    };
  }
};